import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { CREATE_EDIT_PURCHASE_ORDER_FORM_NAME } from 'Common/FormEnum';
import CreateEditPurchaseOrderComponent from '../../components/createEditPurchaseOrder/CreateEditPurchaseOrder';

class CreateEditPurchaseOrderContainer extends Component {
  render() {
    return <CreateEditPurchaseOrderComponent {...this.props} />;
  }
}

export const CreateEditPurchaseOrder = reduxForm({
  form: CREATE_EDIT_PURCHASE_ORDER_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(CreateEditPurchaseOrderContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/containers/createEditPurchaseOrder/CreateEditPurchaseOrder.js